<template>
  <b-row>
    <!-- <pre class="language-json"><code>{{ value }}</code></pre> -->
    <b-col class="div-row-padding">
      <label v-if="value.fieldType == 8">
        <span style="white-space: pre">
          {{ value.value }}
        </span>
      </label>
      <ValidationProvider
        v-else-if="value.fieldType != 22"
        :name="getFieldIdInputName"
        rules="required"
        v-slot="{ validate, passed }"
      >
        <div :class="[{ 'has-success': passed }]">
          <label for="getFieldIdInputName">
            <b-row class="ml-auto">
              <!-- {{value}} -->
              {{ value.fieldName }}
              <b-col class="required" v-if="value.required">*</b-col>
              <b-col>
                <b-icon
                  v-if="value.fieldTip"
                  :title="value.fieldTip"
                  v-b-tooltip.hover
                  icon="info-circle"
                ></b-icon>
              </b-col>
            </b-row>
          </label>
          <!-- <b-row>
            <b-col> <b-icon icon="lightbulb"  aria-hidden="true"/></b-col>
          </b-row> -->
          <b-input-group>
            <!-- Booleano -->
            <!-- {{ value.value }} -->
            <base-imput-logic
              class="ml-0"
              v-if="value.fieldType == 1"
              :options="optionsBoolean"
              :value.sync="value.value"
              :placeholder="value.fieldTip"
              @onDataChange="onDataChange(value)"
            ></base-imput-logic>

            <!-- Data -->
            <b-form-input
              v-if="value.fieldType == 2"
              @input="validate"
              type="date"
              :id="getFieldIdInputName"
              :placeholder="value.fieldTip"
              v-model="value.value"
              :debounce="inputChangeDebounce"
              v-on:update="onDataChange(value)"
            />

            <!-- Hora -->
            <!-- <b-form-timepicker :id="getFieldIdInputName" v-model="value.value"></b-form-timepicker> -->
            <b-form-input
              v-if="value.fieldType == 3"
              @input="validate"
              type="time"
              :id="getFieldIdInputName"
              :placeholder="value.fieldTip"
              v-model="value.value"
              :debounce="inputChangeDebounce"
              v-on:update="onDataChange(value)"
            />

            <!-- Decimal -->
            <b-form-input
              v-if="value.fieldType == 4"
              @input="validate"
              type="text"
              :id="getFieldIdInputName"
              :placeholder="value.fieldTip"
              v-model="value.value"
              v-money-mask
              :debounce="inputChangeDebounce"
              v-on:update="onDataChange(value)"
            />

            <!-- Inteiro -->
            <b-form-input
              v-if="value.fieldType == 5"
              @input="validate"
              type="text"
              :id="getFieldIdInputName"
              :placeholder="value.fieldTip"
              v-model="value.value"
              v-integer-mask
              :debounce="inputChangeDebounce"
              v-on:update="onDataChange(value)"
            />

            <!-- Texto -->
            <b-form-input
              v-if="value.fieldType == 6"
              @input="validate"
              type="text"
              :id="getFieldIdInputName"
              :placeholder="value.fieldTip"
              v-model="value.value"
              :debounce="inputChangeDebounce"
              v-on:update="onDataChange(value)"
            />

            <!-- Lista -->
            <!-- <div
              v-if="value.fieldType == 7"
              class="input-group form-control"
              style="border-color: transparent; padding: 0px; top: -1px"
            >
              <form-fill-field-type-list
                :id="getFieldIdInputName"
                :checklist-value="value"
                :options="value.options"
                @onDataChange="onDataChange"
              >
              </form-fill-field-type-list>
            </div> -->

            <div
              v-if="value.fieldType == 7"
              class="input-group form-control"
              style="border: 0; padding: 0"
            >
              <form-fill-field-type-list
                :id="getFieldIdInputName"
                :checklist-value="value"
                :options="value.options"
                @onDataChange="onDataChange"
              >
              </form-fill-field-type-list>
            </div>

            <!-- QRCode -->
            <b-form-input
              v-if="value.fieldType == 12"
              @input="validate"
              type="text"
              :id="getFieldIdInputName"
              :placeholder="value.fieldTip"
              v-model="value.value"
              :debounce="inputChangeDebounce"
              v-on:update="onDataChange(value)"
            />

            <!-- responsável -->
            <div
              v-if="value.fieldType == 14 && userOptions"
              class="input-group form-control"
              style="border-color: transparent; padding: 0px; top: -1px"
            >
              <form-fill-field-type-list
                :id="getFieldIdInputName"
                :checklist-value="value"
                :options="userOptions"
                @onDataChange="onDataChange"
              >
              </form-fill-field-type-list>
            </div>

            <!-- veículos -->
            <div
              v-if="value.fieldType == 20"
              class="input-group form-control"
              style="border-color: transparent; padding: 0px; top: -1px"
            >
              <form-fill-field-type-list
                :id="getFieldIdInputName"
                :checklist-value="value"
                :options="vehicles"
                @onDataChange="onDataChange"
              >
              </form-fill-field-type-list>
              <!-- <div>vehicles: {{ vehicles }}</div> -->
            </div>

            <!-- Lista Integração -->
            <FormFillFieldTypeIntegration
              v-if="value.fieldType >= 9000"
              id="perPageSelect"
              :fieldId="value.fieldId"
              :value.sync="value.value"
              :selected-value.sync="value.selectedValue"
              :token="token"
            />

            <!-- Apenas Anexo -->
            <b-input-group-append
              v-if="value.fieldType == 10"
              lg="6"
              md="6"
              sm="12"
            >
              <div>
                <div class="div-attachment-only">
                  <camera-button
                    :lang="$i18n.locale"
                    :imageSrc="value.attachment"
                    :originObject="value"
                    @update-image-src="updateImageSrc"
                    style="padding-top: 24px"
                  >
                  </camera-button>
                </div>
              </div>
              <!-- Button-only uploader: hidden input + button trigger -->
              <b-button
                size="sm"
                style="border-radius: 0.4285rem;"
                @click.prevent="$refs.fileOnlyAttachment.click()"
              >
                <span class="icon" style="font-family: Helvetica, Arial, sans-serif">
                  <i class="tim-icons icon-attach-87"></i>
                  {{ $t('geral.escolhaArquivo') }}
                </span>
              </b-button>
              <input
                ref="fileOnlyAttachment"
                type="file"
                style="display: none"
                :lang="$i18n.locale"
                @change="handleFileUpload($event, value)"
              />
            </b-input-group-append>

            <!-- Assinatura -->
            <b-input-group-append
              v-else-if="value.fieldType == 11"
              lg="6"
              md="6"
              sm="12"
            >
              <b-button
                type="button"
                @click.prevent="
                  $refs.fullscreenSidebar.open();
                  $refs.assinatura.show();
                "
                size="sm"
                style="border-radius: 0.4285rem"
              >
                <span
                  class="icon"
                  style="font-family: Helvetica, Arial, sans-serif"
                >
                  <i class="tim-icons icon-pencil"> </i> Adicionar Assinatura
                </span>
              </b-button>
            </b-input-group-append>

            <!-- Anexos -->
            <b-input-group-append
              v-else-if="value.allowsAttachment"
              lg="6"
              md="6"
              sm="12"
            >
              <!-- <div v-if="value.attachmentMobileMode == 2">
                <h1>Teste</h1>
              </div> -->
              <div>
                <div class="div-attachment-photo">
                  <camera-button-append
                    :imageSrc="value.attachment"
                    :originObject="value"
                    @update-image-src="updateImageSrc"
                    style="padding-top: 24px"
                  >
                  </camera-button-append>
                </div>
              </div>
              <label class="file">
                <b-form-file
                  class="tim-icons icon-attach-87"
                  style="width: 0%; padding: 27%; display: none"
                  :lang="$i18n.locale"
                  :placeholder="$t('')"
                  v-on:change="handleFileUpload($event, value)"
                  :no-drop="true"
                />

                <span class="icone">
                  <i
                    class="tim-icons icon-attach-87"
                    style="padding-top: 25%"
                  ></i
                ></span>
              </label>
            </b-input-group-append>

            <!-- objetivo -->
            <base-imput-logic
              class="ml-0"
              v-if="value.fieldType == 13"
              :options="value.options"
              :value.sync="value.value"
              @onDataChange="onDataChange(value)"
            ></base-imput-logic>

            <!-- cnpj -->
            <b-form-input
              v-if="value.fieldType == 15"
              type="text"
              v-model="value.value"
              v-mask="'99.999.999/9999-99'"
              :placeholder="value.fieldTip"
            />
            <!-- cnpj filial -->
            <b-form-input
              v-if="value.fieldType == 16"
              type="text"
              v-model="value.value"
              v-mask="'99.999.999/9999-99'"
              :placeholder="value.fieldTip"
            />

            <!-- cpf -->
            <b-form-input
              v-if="value.fieldType == 17"
              type="text"
              v-model="value.value"
              v-mask="'999.999.999-99'"
              :placeholder="value.fieldTip"
            />
          </b-input-group>
          <!-- area de texto -->
          <b-form-textarea
            v-if="value.fieldType == 18"
            :placeholder="value.fieldTip"
            v-model="value.value"
          />
          <!-- OCR -->
          <div
            v-if="value.fieldType == 21"
            style="
              border-color: transparent;
              padding: 0px;
              top: -10px;
              border: 0;
            "
            class="form-control"
          >
            <ocr-field
              :id="getFieldIdInputName"
              :checklistValue="value"
              @onDataChange="onDataChange"
              @update-image-src="updateValueImageSrc"
              @remove-ocr-attachment="clearOrRemoveFieldData"
            />
          </div>

          <multiselect
            v-if="value.fieldType == 25"
            id="selectSteps"
            class="select-field"
            v-model="value.selectedValues"
            label="text"
            track-by="value"
            :placeholder="value.fieldTip"
            :close-on-select="false"
            :showLabels="false"
            :multiple="true"
            :options="value.options"
          >
          </multiselect>

          <!-- {{ value }} -->
        </div>
      </ValidationProvider>
      <sub-checklist-to-fill
        v-if="value.fieldType == 22"
        :fieldValue.sync="value"
        :checklist="checklist"
        :autosaveValues="autosaveValues"
        :modelstate="modelstate"
        :token="token"
      ></sub-checklist-to-fill>

      <!-- {{ value.attachments }} -->
      <b-row class="text-center" v-if="value.attachments != null">
        <b-col
          md="12"
          v-for="(attachment, i) in listActiveAttachments"
          :key="i"
        >
          <!-- <div>{{ attachment }}</div> -->
          <div v-if="isAttachmentVideo(attachment)">
            <authed-video
              class="ml-3 mb-3"
              :attachmentSrc="attachment.attachment"
              :attachmentUrl="`${$store.getters.urlChecklist}/v3/checklist/value/attachment/${value.id}/${attachment.id}`"
              :attachmentId="attachment.id || attachment.attachmentName"
              :attachmentName="attachment.attachmentName"
              :discard-visible="value.fieldType != 8"
              :token="token"
              @discard="fileRemoveById"
            ></authed-video>
          </div>
          <div v-else-if="isAttachmentImage(attachment)">
            <base-attachment-viewer
              v-if="isAttachmentLocal(attachment)"
              class="ml-3 mb-3"
              :attachment="attachment"
              :attachments="value.attachments"
              :discard-visible="value.fieldType != 8"
              :field-value="value"
              :token="token"
              @discard="fileRemoveByAttachmentObject"
            ></base-attachment-viewer>
            <authed-image
              v-else
              class="ml-3 mb-3"
              :attachmentSrc="`${$store.getters.urlChecklist}/v3/checklist/value/attachment/${value.id}/${attachment.id}`"
              :attachmentId="attachment.id || attachment.attachmentName"
              :attachmentName="attachment.attachmentName"
              :discard-visible="value.fieldType != 8"
              :token="token"
              @discard="fileRemoveById"
            ></authed-image>
          </div>
          <div v-else>
            <authed-document
              id="authed-document"
              :attachmentSrc="`${$store.getters.urlChecklist}/v3/checklist/value/attachment/${value.id}/${attachment.id}`"
              :attachmentId="attachment.id || attachment.attachmentName"
              :attachmentName="attachment.attachmentName"
              :discard-visible="value.fieldType != 8"
              :token="token"
              @discard="fileRemoveById"
            ></authed-document>
          </div>
        </b-col>
      </b-row>
      <span v-if="hasProblem" class="text-danger">
        {{ getProblemText() }}
      </span>
    </b-col>
    <fullscreen-sidebar
      ref="fullscreenSidebar"
      @onHide="$refs.assinatura.hide()"
      @onShown="$refs.assinatura.show()"
    >
      <template v-slot:content>
        <b-container>
          <base-signature
            ref="assinatura"
            @update-image-src="updateValueImageSrc"
          >
          </base-signature>
        </b-container>
      </template>
    </fullscreen-sidebar>
  </b-row>
</template>

<script>
import axios from "axios";
import { extend } from "vee-validate";
import { required, email, min } from "vee-validate/dist/rules";
extend("required", required);
import AuthedDocument from "@/components_rms/base/AuthedDocument.vue";
import AuthedImage from "@/components_rms/base/AuthedImage.vue";
import AuthedVideo from "@/components_rms/base/AuthedVideo.vue";
import BaseAttachmentViewer from "@/components_rms/base/BaseAttachmentViewer.vue";
import AwesomeMask from "awesome-mask";

export default {
  name: "Fill",
  components: {
    CameraButton: () => import("@/components_rms/CameraButton.vue"),
    CameraButtonAppend: () => import("@/components_rms/CameraButtonAppend.vue"),
    BaseSignature: () => import("@/components_rms/base/BaseSignature.vue"),
    FormFillFieldTypeIntegration: () =>
      import(
        "@/components_rms/checklist/form/FormFillFieldTypeIntegration.vue"
      ),
    FormFillFieldTypeList: () =>
      import("@/components_rms/checklist/form/FormFillFieldTypeList.vue"),
    FullscreenSidebar: () => import("@/components_rms/FullscreenSidebar.vue"),
    BaseImputLogic: () => import("@/components_rms/base/BaseImputLogic.vue"),
    OcrField: () => import("@/components_rms/checklist/ocr/OcrField.vue"),
    SubChecklistToFill: () =>
      import("@/components_rms/checklist/form/subForm/SubChecklistToFill.vue"),
    AuthedDocument,
    AuthedImage,
    AuthedVideo,
    BaseAttachmentViewer,
  },
  directives: {
    mask: AwesomeMask,
  },
  props: {
    value: Object,
    fieldId: Number,
    autosaveValues: Array,
    checklist: Object,
    modelstate: Object,
    token: {
      description: "Token de acesso",
      type: String,
      required: true,
    },
  },
  data: function () {
    return {
      inputChangeDebounce: 5000,
      optionsBoolean: [
        { value: "true", text: "Sim" },
        { value: "false", text: "Não" },
      ],
      isInputsEnabled: true,
      userOptions: null,
      vehicles: [],
    };
  },
  mounted() {
    if (this.value.fieldType == 14) this.getUserOptions();
    if (this.value.fieldType == 20) this.getVehicles();
  },
  computed: {
    getFieldIdInputName() {
      return "input" + this.fieldId.toString();
    },
    hasProblem() {
      if (this.getProblemText().length > 0) {
        return true;
      }
      return false;
    },
    listActiveAttachments() {
      return this.value.attachments.filter((f) => f.active);
    },
    state() {
      return this.value.value.length == 1;
    },
  },
  methods: {
    createAttachmentByBloc(blocContent, fileExtension) {
      let newGuid = this.generateUUID();
      return {
        id: null, // id: newGuid,
        active: true,
        attachment: blocContent,
        attachmentName: `${newGuid}.${fileExtension}`,
        createdOn: this.getDateTimeNow(),
      };
    },
    fileRemoveByAttachmentObject(attachment) {
      // If the attachment doesn't have a persisted id yet (local upload),
      // deactivate only this specific object to avoid removing all null-id items.
      if (attachment == null) return;
      if (attachment.id == null || attachment.id === undefined) {
        attachment.active = false;
        this.onDataChange(this.value);
        this.$forceUpdate();
        return;
      }
      this.fileRemoveById(attachment.id);
    },
    fileRemoveById(attachmentId) {
      this.value.attachments.forEach((item) => {
        // Match by id when present; otherwise allow matching by unique attachmentName
        // to avoid deactivating all items with null id.
        const isMatch =
          attachmentId === item.id || attachmentId === item.attachmentName;
        if (isMatch) {
          item.active = false;
          this.onDataChange(this.value);
          this.$forceUpdate();
        }
      });
      if (this.value.fieldType == 21) {
        this.clearOrRemoveFieldData(this.value.fieldId);
      }
    },
    clearOrRemoveFieldData(fieldId) {
      let attachmentFound = false;
      this.value.attachments.forEach((item) => {
        if (this.value.fieldId == fieldId) {
          this.value.value = "";
          item.active = false;
          this.onDataChange(this.value);
          this.$forceUpdate();
          attachmentFound = true;
        }
      });
      if (!attachmentFound) {
        this.value.value = "";
        this.value.attachments = [];
        this.onDataChange(this.value);
        this.$forceUpdate();
      }
    },
    getProblemText() {
      if (this.modelstate) {
        let modelstateText = this.modelstate[this.value.fieldId.toString()];
        if (modelstateText) {
          return modelstateText.toString();
        }
      }
      return "";
    },
    handleFileUpload(event, object) {
      const fileElement = event.target;
      if (!fileElement.files) return;
      if (fileElement.files.length == 0) return;
      if (!fileElement.files[0]) return;

      const reader = new FileReader();
      const file = fileElement.files[0];
      const fileExtension = file.name.split(".").pop();

      if (this.isVideoExtension(fileExtension)) {
        reader.addEventListener(
          "load",
          () => {
            object.attachments.push(
              this.createAttachmentByBloc(reader.result, fileExtension)
            );
            object.attachment = null;
            this.onDataChange(object);
          },
          false
        );
        if (file) {
          reader.readAsDataURL(file);
        }
      } else if (this.isImageExtension(fileExtension)) {
        if (file.size <= 500000) {
          reader.addEventListener(
            "load",
            () => {
              object.attachments.push(
                this.createAttachmentByBloc(reader.result, fileExtension)
              );
              object.attachment = null;
              this.onDataChange(object);
            },
            false
          );
        } else {
          reader.onload = (e) => {
            var img = document.createElement("img");
            img.src = e.target.result;

            img.onload = () => {
              var canvas = document.createElement("canvas");
              var ctx = canvas.getContext("2d");
              ctx.drawImage(img, 0, 0);

              var MAX_WIDTH = 1920;
              var MAX_HEIGHT = 1920;
              var width = img.width;
              var height = img.height;

              if (width > height) {
                if (width > MAX_WIDTH) {
                  height *= MAX_WIDTH / width;
                  width = MAX_WIDTH;
                }
              } else {
                if (height > MAX_HEIGHT) {
                  width *= MAX_HEIGHT / height;
                  height = MAX_HEIGHT;
                }
              }
              canvas.width = width;
              canvas.height = height;
              var ctx = canvas.getContext("2d");
              ctx.drawImage(img, 0, 0, width, height);

              const draftImageSrc = canvas.toDataURL("image/jpeg", 0.5);
              // const draftImageSrc = canvas.toDataURL("image/jpeg");
              this.updateImageSrc(object, draftImageSrc);
            }; // img.onload
          };
        }
        reader.readAsDataURL(file);
      } else {
        reader.addEventListener(
          "load",
          () => {
            const newAttachment = this.createAttachmentByBloc(
              reader.result,
              fileExtension
            );
            object.attachments.push(newAttachment);
            object.attachment = null;
            this.onDataChange(object);
          },
          false
        );
        if (file) {
          reader.readAsDataURL(file);
        }
      }
    },
    isAttachmentLocal(ckAttach) {
      if (ckAttach.attachment == null) return false;
      if (ckAttach.attachment == "") return false;
      return true;
    },
    isAttachmentImage(attachment) {
      if (attachment.attachmentName.endsWith(".jpeg")) return true;
      if (attachment.attachmentName.endsWith(".jpg")) return true;
      if (attachment.attachmentName.endsWith(".png")) return true;
      return false;
    },
    isAttachmentVideo(attachment) {
      return attachment.attachmentName.endsWith(".mp4");
    },
    isImageExtension(fileExtension) {
      switch (fileExtension) {
        case "png":
          return true;
        case "jpg":
          return true;
        case "jpeg":
          return true;
      }
      return false;
    },
    isVideoExtension(fileExtension) {
      switch (fileExtension) {
        case "mp4":
          return true;
      }
      return false;
    },
    updateValueImageSrc(newValue) {
      this.value.attachments.push(this.createAttachmentByBloc(newValue, "png"));
      this.value.attachment = null;
      this.onDataChange(this.value);
      this.$forceUpdate();
      this.$refs.fullscreenSidebar.close();
    },
    updateImageSrc(originObject, newValue) {
      originObject.attachments.push(
        this.createAttachmentByBloc(newValue, "png")
      );
      originObject.attachment = null;
      this.onDataChange(originObject);
      this.$forceUpdate();
    },
    onChangeFieldValue(value) {
      if (value) {
        this.value.value = value.value;
      } else {
        this.value.value = "";
      }
      this.onDataChange(this.value);
    },
    async onDataChange(item) {
      if (this.autosaveValues) {
        if (this.checklist.id == 0 || this.checklist.draft) {
          if (this.autosaveValues.indexOf(item) < 0) {
            this.autosaveValues.push(item);
          }
        }
      }
    },
    getUserOptions() {
      axios
        .request({
          url: `${this.$store.getters.urlChecklist}/user/GetDropdownUser/${this.value.fieldId}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        })
        .then((response) => {
          this.userOptions = response.data;
        });
    },
    getVehicles() {
      axios
        .request({
          url: `${this.$store.getters.urlChecklist}/vehicle/GetDropdownVehicle/${this.value.fieldId}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        })
        .then((response) => {
          this.vehicles = response.data;
          this.$forceUpdate();
        });
    },
  },
  watch: {
    value() {
      if (this.value.fieldType == 14) this.getUserOptions();
      if (this.value.fieldType == 20) this.getVehicles();
      // this.selectedValue = {
      //   value: this.value.value,
      //   text: this.value.value,
      // };
    },
  },
};
</script>

<style>
.div-attachment-file {
  display: block;
}

.div-attachment-photo {
  display: none;
}

.div-attachment-only {
  display: none;
}

@media (max-width: 768px) {
  .div-attachment-file {
    display: none;
  }

  .div-attachment-photo {
    display: block;
    margin-top: -1.5rem;
  }

  .file {
    display: none;
  }

  .fileOnlyAttachment {
    display: none;
  }

  .div-attachment-only {
    display: block;
    margin-top: -1.5rem;
  }

  .frameDesk {
    display: none;
  }
}
</style>

<style scope>
.custom-file-label {
  border-color: #2b3553;
  border-top-right-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
}

.custom-file-label::after {
  background-color: #2c3b5d;
  border: none !important;
}

.file {
  background: #2c3b5d;
  width: 3rem;
  height: 38px;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border: none;
}

.icone {
  padding: 30%;
}

.fileOnlyAttachment {
  border: 1px;
  width: 498px;
  height: 35px;
  border-top-right-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.frame {
  border: solid 1px;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.frameDesk {
  border: solid 1px;
  width: 100%;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

#btn-remover .link:hover {
  color: black !important;
}

.required {
  color: #fd5d93;
  margin-left: -13px !important;
}
</style>
